import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bill-paybills-form',
  templateUrl: './bill-paybills-form.component.html',
  styleUrls: ['./bill-paybills-form.component.css']
})
export class BillPaybillsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/bill-paybills/bill-paybills-form/bill-paybills-form.component.ts